import React from "react";
import { Route } from "react-router-dom";
import { APP_URLS } from "../../constants/urlConstants";
import CreateCompany from "../../containers/CompanyScreen/CreateCompany";
import CustomerScreen from "../../containers/CustomerScreen";
import UpdateCustomerScreen from "../../containers/CustomerScreen/UpdateCustomer";

const CustomerRoutes = (props) => {
  const { access = {}, match } = props;
  const { create, read, update = false } = access;
  return (
    <>
      {!!read && (
        <Route
          exact
          path={match.path}
          render={(routeProps) => (
            <CustomerScreen {...routeProps} screenPermissions={access} />
          )}
        />
      )}
      {!!create && (
        <Route
          path={APP_URLS.CUSTOMER.ADD_CUSTOMER}
          component={CreateCompany}
        />
      )}
      {!!update && (
        <Route
          path={APP_URLS.CUSTOMER.EDIT_CUSTOMER}
          render={(routeProps) => <UpdateCustomerScreen {...routeProps} />}
        />
      )}
    </>
  );
};
export default CustomerRoutes;
